import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import '../styles/TemplateTwo.css';

const TemplateTwo = ({ template, onClick }) => {
    const linkIcons = {
        github: faGithub,
        linkedin: faLinkedin,
        youtube: faYoutube,
        upwork: faUpwork,
        telegram: faTelegram,
        facebook: faFacebook,
        website: faLink,
        portfolio: faLink, // Assume generic link icon
        twitter: faTwitter,
        instagram: faInstagram,
        medium: faMedium,
        behance: faBehance,
        dribbble: faDribbble,
        stackoverflow: faStackOverflow,
        angellist: faAngellist,
        quora: faQuora,
        vimeo: faVimeo,
        soundcloud: faSoundcloud
    };

    const linkText = {
        github: 'GitHub',
        linkedin: 'LinkedIn',
        youtube: 'YouTube',
        upwork: 'Upwork',
        telegram: 'Telegram',
        facebook: 'Facebook',
        website: 'Website',
        portfolio: 'Portfolio',
        twitter: 'Twitter',
        instagram: 'Instagram',
        medium: 'Medium',
        behance: 'Behance',
        dribbble: 'Dribbble',
        stackoverflow: 'Stack Overflow',
        angellist: 'AngelList',
        quora: 'Quora',
        vimeo: 'Vimeo',
        soundcloud: 'SoundCloud'
    };

    return (
        <div className="template-two-container" onClick={() => onClick(template?.id)}>
            <div className='image'>
                {template?.image && <img src={template?.image} alt={template?.personName} className="template-two-image" />}
            </div>
            <div className="template-two-content-wrapper">
                <div className="template-two-sidebar">
                    {template?.name && <h1 className="template-two-name" >{template?.name}</h1>}

                    {template?.aboutMe && <p className="template-two-about">{template?.aboutMe}</p>}

                    {template?.languages && (
                        <div className="template-two-languages">
                            <strong><FontAwesomeIcon icon={faLanguage} /> Languages:</strong> {template?.languages.join(', ')}
                        </div>
                    )}
                    {template?.skills && template?.skills.length > 0 && (
                        <div className="template-two-skills">
                            <strong><FontAwesomeIcon icon={faToolbox} /> Skills:</strong> {template?.skills.join(', ')}
                        </div>
                    )}

                    {template?.softwareSkills && template?.softwareSkills.length > 0 && (
                        <div className="template-two-skills">
                            <strong><FontAwesomeIcon icon={faToolbox} /> Software Skills:</strong> {template?.skills.join(', ')}
                        </div>
                    )}

                    {template?.hobbies && template?.hobbies.length > 0 && (
                        <div className="template-two-hobbies">
                            <strong><FontAwesomeIcon icon={faHeart} /> Hobbies:</strong> {template?.hobbies.join(', ')}
                        </div>
                    )}
                </div>
                <div className="template-two-main-content">

                    {template?.contact && (
                        <div className="template-two-work-experience  template-two-work-experience-item">
                            <strong>Contact</strong>
                            {template?.contact?.phone && <p><FontAwesomeIcon icon={faPhone} /> {template?.contact.phone}</p>}
                            {template?.contact?.email && <p><FontAwesomeIcon icon={faEnvelope} /> {template?.contact.email}</p>}
                            {template?.contact?.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} /> {template?.contact.address}</p>}
                        </div>
                    )}

                    {template?.workExperience && template?.workExperience.length > 0 && (
                        <div className="template-two-work-experience">
                            <strong><FontAwesomeIcon icon={faBriefcase} /> Work Experience:</strong>
                            {template?.workExperience.map((experience, index) => (
                                <div key={index} className="template-two-work-experience-item">
                                    {experience.role && <p className="template-two-role">{experience.role} at {experience.company}</p>}
                                    {experience.location && (
                                        <p className="template-two-location">
                                            (
                                            {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                    )}
                                    {experience.description && <p className="template-two-description">{experience.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                    {template?.education && Array.isArray(template?.education) && template?.education.length > 0 && (
                        <div className="template-two-education">
                            <strong><FontAwesomeIcon icon={faGraduationCap} /> Education:</strong>
                            {template?.education.map((edu, index) => (
                                <div key={index} className="template-two-education-item">
                                    {edu.degree && <p className="template-two-degree">{edu.degree} from {edu.institution}</p>}
                                    <p>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    {edu.description && <p className="template-two-description">{edu.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.certificates && template?.certificates.length > 0 && (
                        <div className="template-two-education">
                            <strong><FontAwesomeIcon icon={faGraduationCap} /> Certificates:</strong>
                            {template?.certificates?.map((certificate, index) => (
                                <div key={index} className="template-two-education-item">
                                    <p className="template-two-degree">Title: {certificate.title}</p>
                                    <p className="template-two-institution">Institution: {certificate.institution}</p>
                                    <p className="template-ten-date">
                                        Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}

                    {template?.links && template?.links.length > 0 && (
                        <div className="template-two-links">
                            <strong>Links:</strong>
                            {template.links.map(([key, value]) => (
                                <p key={key}>
                                    <FontAwesomeIcon icon={linkIcons[key] || faLink} /> <a href={value} target="_blank" rel="noopener noreferrer">{linkText[key]}</a>
                                </p>
                            ))}
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
};

export default TemplateTwo;
